import {FC, HTMLAttributes, ReactNode} from 'react';
import {twMerge} from 'tailwind-merge';

import {LayoutProvider} from '../context';

export type SideBySideProps = {
    children: ReactNode;
    className?: HTMLAttributes<HTMLDivElement>['className'];
    classNameLabel?: HTMLAttributes<HTMLDivElement>['className'];
};

const SideBySide: FC<SideBySideProps> = ({
    children,
    className,
    classNameLabel,
}) => (
    <LayoutProvider classNameLabel={classNameLabel} layout="sideBySide">
        <div className={twMerge('side-by-side', className)}>{children}</div>
    </LayoutProvider>
);

export default SideBySide;
